(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ZC-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function initCarousel() {
    const carousels = document.querySelectorAll('.testimonial-gradient__carousel');
    carousels.forEach(carousel => {
      let flkty = Flickity.data(carousel);
      if (!flkty) {
        // Wait for Flickity to attach (Shopify does this async)
        setTimeout(initCarousel, 500);
        return;
      }
      const nextBtn = document.querySelector('.testimonial-gradient__arrow--next');
      const prevBtn = document.querySelector('.testimonial-gradient__arrow--prev');
      if (nextBtn) nextBtn.addEventListener('click', () => flkty.next(true));
      if (prevBtn) prevBtn.addEventListener('click', () => flkty.previous(true));
    });
    console.log(Flickity.data(document.querySelector('.testimonial-gradient__carousel')))
  }

  // Shopify sometimes loads Flickity after DOMContentLoaded
  window.addEventListener('shopify:section:load', initCarousel);
  setTimeout(initCarousel, 800); // fallback for slower themes
});


document.addEventListener('DOMContentLoaded', function() {
  function initCustomDots() {
    const carousels = document.querySelectorAll('.testimonial-gradient__carousel');
    carousels.forEach(carousel => {
      const flkty = Flickity.data(carousel);
      if (!flkty) {
        setTimeout(initCustomDots, 500);
        return;
      }

      const dotContainer = carousel.parentElement.querySelector('.testimonial-gradient__custom-dots');
      dotContainer.innerHTML = ''; // clear existing dots

      // create one dot per slide
      flkty.slides.forEach((slide, index) => {
        const dot = document.createElement('div');
        dot.classList.add('dot');
        if (index === flkty.selectedIndex) dot.classList.add('active');

        // click on dot to jump
        dot.addEventListener('click', () => flkty.select(index));
        dotContainer.appendChild(dot);
      });

      // update active dot on change
      flkty.on('change', index => {
        dotContainer.querySelectorAll('.dot').forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
        });
      });
    });
  }

  window.addEventListener('shopify:section:load', initCustomDots);
  setTimeout(initCustomDots, 800);
});


  } catch(e) { console.error(e); }
})();
})();
